export default [{
  UserTypeId: 1,
  Name: 'Member'
}, {
  UserTypeId: 2,
  Name: 'Regulator'
}];



// WEBPACK FOOTER //
// ./common/utilities/user-type.js